import { ReactNode, forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { CommonFieldAtomProps } from '../atoms/types';
import { FieldWrapperStyles } from './field-wrapper.styles';

// TODO: add color theming prop so it can be used on non-white bgs
// need input from design on what those options and styles should be
interface FieldWrapperProps extends Omit<CommonFieldAtomProps, 'id'> {
  className?: string;
  mode?: 'light' | 'dark';
  children: ReactNode;
  hasPadding?: boolean;
}

export const FieldWrapper = forwardRef<HTMLDivElement, FieldWrapperProps>(
  ({ active, children, className, disabled, hasError, hasPadding, ...props }, ref) => {
    const wrapperClassName = FieldWrapperStyles.fieldWrapper({ disabled, hasError, active, hasPadding });

    return (
      <div className={cx(wrapperClassName, className)} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);
